<template>
  <div>
    <el-progress v-if="socket_key" :percentage="progress"></el-progress>
    <div class="search-wrap">
      <el-button size="mini" @click="pageChange(1)">查询</el-button>
<!--      <el-button size="mini" @click="computeDosageNumber()">生成</el-button>-->
      <el-button size="mini" @click="getExcel()">导出分摊明细表</el-button>
      <el-button size="mini" @click="getOrderExcel()">导出分摊合计到户表</el-button>
      <el-button size="mini" @click="getSalesExcel()">导出物业收费表</el-button>
    </div>
    <div>
      <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
        <el-descriptions-item label="项目房产">
          {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
        </el-descriptions-item>
        <el-descriptions-item label="抄表月份">
          <el-date-picker
            v-model="mainObj.read_month"
            size="mini"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            @change="pageChange(1)"
            placeholder="选择月">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="客户房产">
          <el-autocomplete
            style="min-width: 400px;max-width: 100%"
            size="mini"
            v-model="mainObj.house_name"
            :fetch-suggestions="querySearchAsyncRoom"
            @select="handleSelect"
            placeholder="请输入房产"
            popper-class="autocomplete-room"
            clearable
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label-class-name="descriptions-label-class" label="客户名称">
          <el-autocomplete
            class="w-300"
            size="mini"
            v-model="where.customer_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入姓名"
            @select="handleSelect2"
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="仪表编号">
          <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" @change="pageChange(1)" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="仪表名称">
          <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="仪表类型">
          <el-select size="mini" style="width: 100%" v-model="where.meter_type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="能耗类型">
          <el-checkbox-group v-model="where.apportion_meter_types" @change="pageChange(1)">
            <el-checkbox v-for="item in apportion_meter_type_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div>
      <div class="header-tip">
        总计收费 【分摊能耗 [成本] + {{user_type==1?'业主':'物业'}}能耗 [销售]】： {{formatMoney(order_count_obj.all_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
        分摊能耗 [成本]： {{formatMoney(order_count_obj.allocated_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
        {{user_type==1?'业主':'物业'}}能耗 [销售]： {{formatMoney(order_count_obj.total_sales_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
    </div>
    <div>
      <el-table show-summary v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="calc(100vh - 360px)" >
        <el-table-column type="selection" width="55"></el-table-column>
        <!--        <el-table-column prop="id" label="id" width="80"></el-table-column>-->
        <el-table-column prop="customer_name" label="客户" width="180"></el-table-column>
        <el-table-column prop="h_name_date" label="房产" width="320"></el-table-column>
        <el-table-column prop="apportion_tip_name" label="分摊类型" width="100">
          <!--          <template slot-scope="scope">-->
          <!--            {{scope.row.apportion_meter_type==1?'纯用量分摊':'线损分摊'}}-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="apportion_type_name" label="分摊模式" width="100"></el-table-column>
        <el-table-column prop="dosage_number" label="总用量" width="100">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.dosage_fun_name" placement="bottom">
              <span>{{scope.row.dosage_number}}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="xsc_Price" label="单价" width="100"></el-table-column>
        <el-table-column prop="amount" label="总费用" width="100"></el-table-column>
        <el-table-column prop="xsc_Amount" label="公摊用量" width="100"></el-table-column>
        <el-table-column prop="charge" label="公摊费用" width="100">
          <template slot-scope="scope">
            <span style="color: #000000;font-weight: bold">{{scope.row.charge}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="charge_name" label="费项" width="150"></el-table-column>
        <el-table-column prop="charge_name" label="公摊单价（参照）" width="120">
          <template slot-scope="scope">
            {{reNumber(scope.row.amount/scope.row.proportion_total*scope.row.proportion_ext)}}
          </template>
        </el-table-column>
        <el-table-column prop="charge_name" label="公摊费用（参照）" width="120">
          <template slot-scope="scope">
            {{reNumber(scope.row.amount/scope.row.proportion_total*scope.row.proportion_ext*scope.row.proportion_value)}}
          </template>
        </el-table-column>
        <el-table-column prop="number" label="仪表编号 "  width="150">
          <template slot-scope="scope">
            <el-link type="primary">{{scope.row.number||'无仪表编号'}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="仪表名称 " width="250"></el-table-column>
        <el-table-column prop="meter_level" label="仪表等级 " width="100"></el-table-column>
        <el-table-column prop="proportion_value" label="系数（单户面积）" width="120"></el-table-column>
        <el-table-column prop="proportion_total" label="基数（总面积）" width="120"></el-table-column>
        <el-table-column prop="proportion" label="占比" width="100"></el-table-column>
        <el-table-column prop="proportion_ext" label="扩展占比" width="100"></el-table-column>
        <el-table-column label="操作 " width="100">
          <template slot-scope="scope">
            <!--            <el-button type="primary" size="mini" icon="el-icon-edit" @click="update(scope.row)" v-if="ERP.isPermission(4007002006)||ERP.isPermission(21004001006)||ERP.isPermission(8006001006)||ERP.isPermission(30006001006)">能耗</el-button>-->

          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 20px;text-align: center;margin-right: 20px;">
      <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
    </div>

  </div>
</template>

<script>
import {Loading} from "element-ui";
import AppConfig from "../../../../../../config/AppConfig";
import MeterHttp from "../../../common/MeterHttp";

export default {
  name: "MeterOrderObjectFlowList",
  inject:['mainObj','order_query'],
  data(){
    return{
      where:{
        number:"",
        name:"",
        apportion_meter_types:[1,2],
        meter_type:"",
        house_id:"",
        house_name:"",
        customer_id:"",
        customer_name:"",
      },
      apportion_meter_type_list:[{name:"存用量",val:1},{name:"线损",val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      energy_obj:{1:"业主能耗",2:"物业能耗",3:"分摊能耗"},
      meter_type_list: [],
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      multipleSelection: [],
      order_count_obj:{
        allocated_amount:0,
        total_dosage_number:0,
        total_sales_amount:0,
        all_amount:0,
      },
      progress: 0,
      socket_key:null,
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.pageChange(1)
  },
  methods:{
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderObject/getList",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:that.user_type,
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      });
      MeterHttp.post("MeterOrderObject/getDataStatistics",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:that.user_type,
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if(res.code){
          that.order_count_obj=res.data;
        }
      })
    },
    computeDosageNumber(){
      const that = this;
      let where = ERP.reJson(this.where);
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      let loadingInstance = Loading.service({ fullscreen: true });
      MeterHttp.post("MeterOrderObject/computeDosageNumber",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:that.user_type,
      }, res => {
        loadingInstance.close();
        if (res.code) {
          that.pageChange(1)
        }
      })
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      // this.where.house_id=item.id||0;
      this.mainObj.house_name=item.value;
      this.pageChange(1);
    },
    querySearchAsync(queryString, cb) {
      const that = this;
      if(!queryString){
        cb([])
        return false
      }
      let from_data={}
      from_data.key_name=queryString;
      ERP.getRequest({url:"admin/Customer/getCustomerList",data:from_data},res=>{
        if (res.code) {
          cb(res.data.map(ret=>{return {
            value:`${ret.name}-【${(ret.house_list.map(re=>re.address).join(','))}】`,//
            id:ret.id,
            data:ret
          }}));
        }
      })
    },
    handleSelect2(item) {
      const that = this;
      // that.where.customer_id=item.data.id||0;
      that.where.customer_name=item.data.name;
      that.pageChange(1);
    },
    reNumber(x){
      return Math.floor(x*10000)/10000
    },
    getExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderObject/getExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:that.user_type,
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.initTaskClient(res.data,()=>{

          })
        }
        that.loading = false;
      })
    },
    getOrderExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderObject/getOrderExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:that.user_type,
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.initTaskClient(res.data,()=>{

          })
        }
        that.loading = false;
     })
    },
    getSalesExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;

      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderObject/getSalesExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:that.user_type,
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.initTaskClient(res.data,()=>{

          })
        }
        that.loading = false;
     })
    },
    initTaskClient(socket_key,callback){
      const that = this;
      that.socket_key = socket_key;
      MeterHttp.post("TaskClient/getTask",{socket_key: socket_key}, res => {
        if (res.code==1) {
          that.progress = res.data.progress||0;
          if(res.data.progress==100){
            that.$message.success(res.msg || "数据异常");
            that.socket_key = null;
            if(res.data.filepath.indexOf('http')==-1){
              res.data.filepath=AppConfig.erp_server+'/'+res.data.filepath
            }
            window.open(res.data.filepath)
            callback && callback()
          }else{
            setTimeout(() => {
              that.initTaskClient(socket_key,callback)
            }, 2000)
          }

        }else {
          that.socket_key = null;
          that.$message.error(res.msg || "数据异常");
          callback && callback()
        }
      })
    },
  },
  computed:{
    user_type(){
      return this.order_query.user_type
    }
  },
  watch:{
    "mainObj.house_name":function (n,o) {
      if(n){
        this.pageChange(1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order_flow/components/MeterOrderObjectFlowList.vue